

export function sortAlpha(prop: string) {
    return (a: any, b: any) => {
        return a[prop].localeCompare(b[prop]);
    };
}

export function sortAlphaDesc(prop: string) {
    return (a: any, b: any) => {
        return b[prop].localeCompare(a[prop]);
    };
}
